import Vue from 'vue'
import App from './App.vue'
import router from './router'

import Bootstrap from 'bootstrap/dist/css/bootstrap.css'
import BootstrapVue from 'bootstrap-vue'
import FontAwesome from 'fontawesome-4.7/css/font-awesome.css'
import './assets/css/abgasskandal.css'
import VueSignaturePad from 'vue-signature-pad'
import VTooltip from 'v-tooltip'
import VueGtag from "vue-gtag";
import Vuelidate from 'vuelidate';

Vue.use(Bootstrap);
Vue.use(BootstrapVue);
Vue.use(FontAwesome);
Vue.use(VueSignaturePad);
Vue.use(VTooltip);
Vue.use(Vuelidate);

Vue.config.productionTip = false

const global = Vue.observable({value: {}})
Object.defineProperty(Vue.prototype, '$global', {
  get () {
    return global.value
  },
  set (value) {
    global.value = value
  }
})

// Configuration VueAnalytics
Vue.use(VueGtag, {
  config: {
    id: "UA-26670104-1",
    params: {
      send_page_view: true
    }
  },
  includes: [
    { id: 'AW-1010838723' }
  ]
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
